import React from 'react';
import { Typography } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ spacing, typography }) => ({
    root: {},
    givingInstructionsTitle: {
        fontWeight: typography.fontWeightBold,
    },
    givingMethodTitle: {
        marginTop: spacing(2),
        fontWeight: typography.fontWeightBold,
    },
    givingMethodBullettedList: {
        margin: [[0, 0, 0, spacing(2)]],
        wordWrap: 'break-word',
    },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function HongKongEnglishGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_hong_kong`,
        classes.root,
    );

    const givingMethodTitleClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_title`,
        classes.givingMethodTitle,
    );

    const givingMethodBullettedListClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_bulleted_list`,
        classes.givingMethodBullettedList,
    );

    return (
        <div className={rootClassNames}>
            <Typography
                // eslint-disable-next-line max-len
                className={ClassNames(classes.givingInstructionsTitle, `${BEM_BLOCK_NAME}--giving_instructions_title`)}
                component="div"
                variant="body1"
            >
                {`${campaignName} Offering Method`}
            </Typography>

            <div className={givingMethodTitleClassNames}>1. By Check or Cash</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>{`Put your cash or check donation in the “${campaignName}” donation envelope`}</li>
                <li>Please write checks to “Saddleback Hong Kong”</li>
                {/* eslint-disable max-len */}
                <li>Fill out your English Full Name (same as your Hong Kong Identity Card), telephone number, email address</li>
                <li>Please also share your correspondence address to Accounting Team if you need a tax receipt</li>
                {/* eslint-enable max-len */}
            </ul>

            <div className={givingMethodTitleClassNames}>2. By FPS (Faster Payment System)</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>FPS Telephone no. 57410041</li>
                <li>{`Please write “${campaignName}”, your English Full Name (same as your Hong Kong Identity Card), telephone number, email address at message/reference box before payment`}</li>
                <li>
                    Please SCREENSHOT the successful page to Accounting Team email:
                    {'\u00a0'}
                    <a href="mailto:ACTeam@saddleback.hk">ACTeam@saddleback.hk</a>
                    {'\u00a0'}
                    or whatsapps: 57410041
                </li>
                {/* eslint-disable-next-line max-len */}
                <li>Please also share your correspondence address to Accounting Team if you need a tax receipt</li>
            </ul>

            <div className={givingMethodTitleClassNames}>3. By PayMe</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>
                    Scan the PayMe code or use the following link:
                    {'\u00a0'}
                    <a href="https://qr.payme.hsbc.com.hk/2/U4aE6ai3LTTx6mw5PdRoCF">https://qr.payme.hsbc.com.hk/2/U4aE6ai3LTTx6mw5PdRoCF</a>
                </li>
                <li>{`Please write “${campaignName}”, your English Full Name (same as your Hong Kong Identity Card), telephone number, email address at message/reference box before payment`}</li>
                <li>
                    Please SCREENSHOT the successful page to Accounting Team email:
                    {'\u00a0'}
                    <a href="mailto:ACTeam@saddleback.hk">ACTeam@saddleback.hk</a>
                    {'\u00a0'}
                    or whatsapps: 57410041
                </li>
                {/* eslint-disable-next-line max-len */}
                <li>Please also share your correspondence address to Accounting Team if you need a tax receipt</li>
            </ul>
        </div>
    );
}

export default HongKongEnglishGivingInstructions;
